import React from 'react';
import Upload from './Upload';
import { AppContext } from '../../App';
import { ITrainingSet } from '../../types/my-types';
import { UploadContext } from './UploadContext';

interface Props {
  trainingSet?: ITrainingSet;
  trainingSetError?: boolean;
  isExtraction: boolean;
  isUpdate?: boolean;
  dismissModal: () => void;
}

const UploadPicker: React.FC<Props> = (props) => {
  const { option } = React.useContext(UploadContext);

  return (
    <div id="upload-picker" style={{ width: '100%' }}>
      <>
        <div style={{ display: `${option === 2 || option === 0 ? '' : 'none'}` }}>
          <Upload
            isExtraction={props.isExtraction}
            isUpdate={props.isUpdate}
            trainingSet={props.trainingSet}
            dismissModal={props.dismissModal}
          />
        </div>
      </>
    </div>
  );
};

export default UploadPicker;
